import { render, staticRenderFns } from "./ActivityAndSettings.vue?vue&type=template&id=00888d7e&scoped=true&"
import script from "./ActivityAndSettings.vue?vue&type=script&lang=js&"
export * from "./ActivityAndSettings.vue?vue&type=script&lang=js&"
import style0 from "./ActivityAndSettings.vue?vue&type=style&index=0&id=00888d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00888d7e",
  null
  
)

export default component.exports